import React from "react";
import ReactDOM from "react-dom/client";
import CheckoutApp from "./checkout/App";
import BusinessConfiguratorApp from "./business-configurator/App";
import ConfiguratorApp from "./configurator/App";
import PaymentApp from "./payment/App";
import StatusAppointmentApp from "./status/appointment/App";
import StatusPaymentApp from "./status/payment/App";
import AppointmentApp from "./appointment/App";
import AppointmentCreatedApp from "./appointment/created/App";
import { REACT_APP_LOCAL_STYLING } from "../../shared/config";

import "../styles/index.scss";
// import "../styles/slick-theme.css";
import "../styles/slick.css";
// import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-toastify/dist/ReactToastify.css";
import SamplesApp from "./samples/App";

if (REACT_APP_LOCAL_STYLING.toLowerCase?.() === "true") {
  import("../styles/index-local.scss");
}

export type AppProps = {
  configuration: AppConfiguration;
};

export type AppConfiguration = {
  basename?: string;
};

export class BaseApp {
  configuration: AppConfiguration;
  htmlSelector: string;

  constructor(htmlSelector: string, configuration: AppConfiguration) {
    this.configuration = configuration;
    this.htmlSelector = htmlSelector;
  }

  public render = () => {
    const root = ReactDOM.createRoot(
      document.querySelector(this.htmlSelector) as HTMLElement,
    );

    root.render(
      <React.StrictMode>
        <CheckoutApp configuration={this.configuration} />
        <BusinessConfiguratorApp configuration={this.configuration} />
        <ConfiguratorApp configuration={this.configuration} />
        <PaymentApp configuration={this.configuration} />
        <StatusAppointmentApp configuration={this.configuration} />
        <StatusPaymentApp configuration={this.configuration} />
        <AppointmentApp configuration={this.configuration} />
        <AppointmentCreatedApp configuration={this.configuration} />
        <SamplesApp configuration={this.configuration} />
      </React.StrictMode>,
    );
  };
}
